import { i18n } from "@/i18n";
import { accessManager } from "@/services/security/access-manager";
import { analyticsTagsConstantes } from "@/constantes/analyticsTags";
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";

export default {
  path: "/studea-manager/:trainingCourseId",
  name: "studeaManagerLayout",
  redirect: { name: "studeaManagerHome" },
  component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/LayoutView.vue"),
  meta: {
    title: i18n.global.t("studea_manager.home.page_title"),
    breadcrumb: true,
    authRequired: true,
  },
  children: [
    {
      path: "config",
      name: "studeaManagerHome",
      component: () =>
        import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/StudeaManagerHomeView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.home.page_title"),
        breadcrumb: false,
      },
    },
    {
      path: "skin",
      name: "studeaManagerSkin",
      component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/HomeView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.skin.list.title"),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_TRAINING_DESIGN,
        access: accessManager.EDIT,
      },
    },
    {
      path: "triad",
      name: "studeaManagerTriad",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerTriadList" },
      meta: {
        title: i18n.global.tc("global.list.title", 1, {
          name: i18n.global.tc("studea_manager.triad.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
      },
      children: [
        {
          path: "",
          name: "studeaManagerTriadList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Triad/TriadListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.triad.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
            access: accessManager.VIEW,
          },
        },
        {
          path: ":alias(triad)/add",
          name: "studeaManagerTriadAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.triad.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
            access: accessManager.EDIT,
            trackSubmitTagId: analyticsTagsConstantes.PILOT_TRIAD_ADD_TRIAD_FORM,
          },
        },
        {
          path: ":alias(triad)/edit/:id",
          name: "studeaManagerTriadEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.triad.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
            access: accessManager.EDIT,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_TRIAD_EDIT,
          },
        },
        {
          path: ":alias(crew)/add",
          name: "studeaManagerCrewAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.crew.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
            access: accessManager.EDIT,
            trackSubmitTagId: analyticsTagsConstantes.PILOT_TRIAD_ADD_GROUP_FORM,
          },
        },
        {
          path: ":alias(crew)/edit/:id",
          name: "studeaManagerCrewEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.crew.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
            access: accessManager.EDIT,
          },
        },
        {
          path: "send-user-infos",
          name: "studeaManagerTriadSendUserInfos",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Triad/SendUserInfosView.vue"),
          meta: {
            title: i18n.global.t("studea_manager.triad.send_user_infos"),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
            access: accessManager.VIEW,
          },
        },
        {
          path: ":alias(contract)/:triadId",
          name: "studeaManagerContract",
          component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
          redirect: { name: "studeaManagerContractList" },
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.contract.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
          },
          children: [
            {
              path: "list",
              name: "studeaManagerContractList",
              component: () =>
                import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Triad/ContractListView.vue"),
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("studea_manager.contract.title", 2).toLowerCase(),
                }),
                breadcrumb: false,
                code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
                access: accessManager.VIEW,
                trackPageView: true,
                trackPageViewTagId: analyticsTagsConstantes.PILOT_TRIAD_CONTRACT_MANAGEMENT,
              },
            },
            {
              path: "add",
              name: "studeaManagerContractAdd",
              component: () =>
                import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Triad/ContractEditView.vue"),
              meta: {
                title: i18n.global.tc("global.add.title", 1, {
                  name: i18n.global.tc("studea_manager.contract.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
                access: accessManager.EDIT,
              },
            },
            {
              path: "edit/:id",
              name: "studeaManagerContractEdit",
              component: () =>
                import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Triad/ContractEditView.vue"),
              meta: {
                title: i18n.global.tc("global.edit.title", 1, {
                  name: i18n.global.tc("studea_manager.contract.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
                access: accessManager.EDIT,
              },
            },
          ],
        },
        {
          path: ":alias(studea-user)/add",
          name: "studeaManagerUserAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.user.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD,
            access: accessManager.EDIT,
            postNotGeneric: true,
            putNotGeneric: true,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_TRIAD_ADD_USER_FORM,
          },
        },
        {
          path: ":alias(triad)/import",
          name: "studeaManagerTriadImport",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/ImportView.vue"),
          meta: {
            title: i18n.global.tc("global.import.title", 1, {
              name: i18n.global.tc("studea_manager.triad.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD_IMPORT,
            access: accessManager.EDIT,
            trackSubmitTagId: analyticsTagsConstantes.PILOT_TRIAD_IMPORT_FORM,
          },
        },
        {
          path: ":alias(triad)/update",
          name: "studeaManagerTriadUpdate",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/ImportView.vue"),
          meta: {
            title: i18n.global.tc("global.update.title", 1, {
              name: i18n.global.tc("studea_manager.triad.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerTriadList",
            code: studeaManagerManager.STUDEA_MANAGER_TRIAD_IMPORT,
            access: accessManager.EDIT,
            trackSubmitTagId: analyticsTagsConstantes.PILOT_TRIAD_COMPLETE_FORM,
          },
        },
      ],
    },
    {
      path: "questionnaire",
      name: "studeaManagerQuestionnaire",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerQuestionnaireList" },
      meta: {
        title: i18n.global.tc("global.list.title", 1, {
          name: i18n.global.tc("studea_manager.questionnaire.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_QUESTIONNAIRES,
        generic: "studea_manager",
      },
      children: [
        {
          path: "",
          name: "studeaManagerQuestionnaireList",
          component: () =>
            import(
              /* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Questionnaire/QuestionnaireListView.vue"
            ),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.questionnaire.title", 2).toLowerCase(),
            }),
            code: studeaManagerManager.STUDEA_MANAGER_QUESTIONNAIRES,
            access: accessManager.VIEW,
            breadcrumb: false,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_QUESTIONNAIRE_SETTINGS,
          },
        },
        {
          path: "add",
          name: "studeaManagerQuestionnaireAdd",
          component: () =>
            import(
              /* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Questionnaire/QuestionnaireAddEditView.vue"
            ),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.questionnaire.title", 1).toLowerCase(),
            }),
            code: studeaManagerManager.STUDEA_MANAGER_QUESTIONNAIRES,
            access: accessManager.EDIT,
            breadcrumb: true,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_QUESTIONNAIRE_ADD_FORM,
          },
        },
        {
          path: "edit/:id",
          name: "studeaManagerQuestionnaireEdit",
          component: () =>
            import(
              /* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Questionnaire/QuestionnaireAddEditView.vue"
            ),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.questionnaire.title", 1).toLowerCase(),
            }),
            code: studeaManagerManager.STUDEA_MANAGER_QUESTIONNAIRES,
            access: accessManager.EDIT,
            breadcrumb: true,
          },
        },
      ],
    },
    {
      path: "skill",
      name: "studeaManagerSkill",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerSkillConfiguration" },
      meta: {
        title: i18n.global.tc("global.list.title", 2, {
          name: i18n.global.tc("studea_manager.skill.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: "STUDEA_MANAGER_SKILLS",
        generic: "studea_manager",
      },
      children: [
        {
          path: "",
          name: "studeaManagerSkillList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Skill/SkillListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 2, {
              name: i18n.global.tc("studea_manager.skill.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.VIEW,
          },
        },
        {
          path: ":alias(skill-session)/edit/:id",
          name: "studeaManagerSkillSessionEdit",

          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 2, {
              name: i18n.global.tc("studea_manager.skillSession.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSkillList",
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(skill-session)/add",
          name: "studeaManagerSkillSessionAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 2, {
              name: i18n.global.tc("studea_manager.skillSession.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSkillList",
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.EDIT,
          },
        },
        {
          path: "configuration",
          name: "studeaManagerSkillConfiguration",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Skill/SkillAddEditView.vue"),
          meta: {
            title: i18n.global.t("studea_manager.skill_configuration.title"),
            breadcrumb: true,
            backPath: "studeaManagerHome",
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.EDIT,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_SKILL_SETTINGS,
          },
        },
        {
          path: "referential",
          name: "studeaManagerSkillReferentialConfigurationLayout",
          redirect: {
            name: "studeaManagerSkillReferentialConfiguration",
          },
          component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
          meta: {
            title: i18n.global.t("studea_manager.skill_referential.title"),
            breadcrumb: true,
            backPath: "studeaManagerSkillList",
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.EDIT,
          },
          children: [
            {
              path: "",
              name: "studeaManagerSkillReferentialConfiguration",
              component: () =>
                import(
                  /* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Skill/SkillReferencialListView.vue"
                ),
              meta: {
                title: i18n.global.tc("global.add.title", 2, {
                  name: i18n.global.tc("studea_manager.skillReferential.title", 1).toLowerCase(),
                }),
                breadcrumb: false,
                backPath: "studeaManagerSkillReferentialConfiguration",
                code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
                access: accessManager.EDIT,
              },
            },
            {
              path: ":alias(skill-referential)/add",
              name: "studeaManagerSkillReferentialAdd",
              component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
              meta: {
                title: i18n.global.tc("global.add.title", 2, {
                  name: i18n.global.tc("studea_manager.skillReferential.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                backPath: "studeaManagerSkillReferentialConfiguration",
                code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
                access: accessManager.EDIT,
              },
            },
            {
              path: ":alias(skill-referential)/edit/:id",
              name: "studeaManagerSkillReferentialEdit",
              component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
              meta: {
                title: i18n.global.tc("global.edit.title", 2, {
                  name: i18n.global.tc("studea_manager.skillReferential.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                backPath: "studeaManagerSkillReferentialConfiguration",
                code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
                access: accessManager.EDIT,
              },
            },
            {
              path: ":alias(skill)/edit/:id",
              name: "studeaManagerSkillEdit",
              component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
              meta: {
                title: i18n.global.tc("global.edit.title", 2, {
                  name: i18n.global.tc("studea_manager.skill.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                backPath: "studeaManagerSkillReferentialConfiguration",
                code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
                access: accessManager.EDIT,
              },
            },
            {
              path: ":alias(skill)/add",
              name: "studeaManagerSkillAdd",
              component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
              meta: {
                title: i18n.global.tc("global.add.title", 2, {
                  name: i18n.global.tc("studea_manager.skill.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                backPath: "studeaManagerSkillReferentialConfiguration",
                code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
                access: accessManager.EDIT,
              },
            },
            {
              path: ":alias(skill-category)/edit/:id",
              name: "studeaManagerSkillCategoryEdit",
              component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
              meta: {
                title: i18n.global.tc("global.edit.title", 2, {
                  name: i18n.global.tc("studea_manager.skillCategory.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                backPath: "studeaManagerSkillReferentialConfiguration",
                code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
                access: accessManager.EDIT,
              },
            },
            {
              path: ":alias(skill-category)/add",
              name: "studeaManagerSkillCategoryAdd",
              component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
              meta: {
                title: i18n.global.tc("global.add.title", 2, {
                  name: i18n.global.tc("studea_manager.skillCategory.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                backPath: "studeaManagerSkillReferentialConfiguration",
                code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
                access: accessManager.EDIT,
              },
            },
            {
              path: ":alias(skill)/import",
              name: "studeaManagerSkillImport",
              component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/ImportView.vue"),
              meta: {
                title: i18n.global.t("studea_manager.skill_import.title"),
                breadcrumb: true,
                backPath: "studeaManagerSkillReferentialConfiguration",
                code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
                access: accessManager.EDIT,
              },
            },
          ],
        },
        {
          path: "referential/session",
          name: "studeaMananerSkillAddSessionReferential",
          component: () =>
            import(
              /* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Skill/SkillAddSessionReferentialView.vue"
            ),
          meta: {
            title: i18n.global.t("studea_manager.skillReferential.use"),
            breadcrumb: true,
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.VIEW,
          },
        },
        {
          path: "generate-questionnaire/:currentSessionId",
          name: "studeaManagerSkillGenerateQuestionnaire",
          component: () =>
            import(
              /* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Skill/SkillGenerateQuestionnaireView.vue"
            ),
          meta: {
            title: i18n.global.t("studea_manager.skill_generate.title"),
            breadcrumb: true,
            backPath: "studeaManagerSkillList",
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.EDIT,
          },
        },

        {
          path: ":alias(skill-type)/list",
          name: "studeaManagerSkillTypeList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Skill/SkillTypeListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.skillType.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSkillList",
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.VIEW,
          },
        },
        {
          path: ":alias(skill-type)/edit/:id",
          name: "studeaManagerSkillTypeEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.skillType.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSkillTypeList",
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(skill-type)/add",
          name: "studeaManagerSkillTypeAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.skillType.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSkillTypeList",
            code: studeaManagerManager.STUDEA_MANAGER_SKILLS,
            access: accessManager.EDIT,
          },
        },
      ],
    },
    {
      path: "template",
      name: "studeaManagerTemplate",
      component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/HomeView.vue"),
      meta: {
        title: i18n.global.tc("global.list.title", 1, {
          name: i18n.global.tc("studea_manager.template.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_MAIL_TEMPLATES,
        access: accessManager.VIEW,
      },
    },
    {
      path: "gradebook",
      name: "studeaManagerGradebook",
      component: () =>
        import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/GradeBook/GradeBookConfigView.vue"),
      meta: {
        title: i18n.global.tc("global.list.title", 1, {
          name: i18n.global.tc("studea_manager.gradebook.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_GRADEBOOK,
        access: accessManager.VIEW,
        generic: "studea_manager",
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_GRADEBOOK_SETTINGS,
      },
    },
    {
      path: ":alias(lesson)",
      name: "studeaManagerLesson",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerLessonList" },
      meta: {
        title: i18n.global.tc("global.list.title", 2, {
          name: i18n.global.tc("studea_manager.lesson.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: "STUDEA_MANAGER_COURSE",
        generic: "studea_manager",
      },
      children: [
        {
          path: "",
          name: "studeaManagerLessonList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Lesson/LessonListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 2, {
              name: i18n.global.tc("studea_manager.lesson.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_COURSE,
            access: accessManager.VIEW,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_COURSE_SETTINGS,
          },
        },
        {
          path: "add",
          name: "studeaManagerLessonAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.lesson.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerLessonList",
            code: studeaManagerManager.STUDEA_MANAGER_COURSE,
            access: accessManager.EDIT,
          },
        },
        {
          path: "edit/:id",
          name: "studeaManagerLessonEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.lesson.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerLessonList",
            code: studeaManagerManager.STUDEA_MANAGER_COURSE,
            access: accessManager.EDIT,
          },
        },
      ],
    },
    {
      path: "subject",
      name: "studeaManagerSubject",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerSubjectList" },
      meta: {
        title: i18n.global.tc("global.list.title", 2, {
          name: i18n.global.tc("studea_manager.subject.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
      },
      children: [
        {
          path: "",
          name: "studeaManagerSubjectList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Lesson/SubjectListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 2, {
              name: i18n.global.tc("studea_manager.subject.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_COURSE,
            access: accessManager.VIEW,
          },
        },
        {
          path: ":alias(subject)/add",
          name: "studeaManagerSubjectAdd",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Subject/AddEditSubjectView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 2, {
              name: i18n.global.tc("studea_manager.subject.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSubjectList",
            code: studeaManagerManager.STUDEA_MANAGER_COURSE,
            access: accessManager.EDIT,
            trackSubmitTagId: analyticsTagsConstantes.PILOT_SETTINGS_SUBJECT_ADD_SUBJECT_FORM,
          },
        },
        {
          path: ":alias(subject)/edit/:id",
          name: "studeaManagerSubjectEdit",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Subject/AddEditSubjectView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 2, {
              name: i18n.global.tc("studea_manager.subject.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSubjectList",
            code: studeaManagerManager.STUDEA_MANAGER_COURSE,
            access: accessManager.EDIT,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_SETTINGS_SUBJECT_EDIT_SUBJECT_FORM,
          },
        },
        {
          path: ":alias(unit)/add",
          name: "studeaManagerUnitAdd",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Unit/AddEditUnitView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 2, {
              name: i18n.global.tc("studea_manager.unit.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSubjectList",
            code: studeaManagerManager.STUDEA_MANAGER_COURSE,
            access: accessManager.EDIT,
            trackSubmitTagId: analyticsTagsConstantes.PILOT_SETTINGS_SUBJECT_ACTIONS_ADD_UNIT_FORM,
          },
        },
        {
          path: ":alias(unit)/edit/:id",
          name: "studeaManagerUnitEdit",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Unit/AddEditUnitView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 2, {
              name: i18n.global.tc("studea_manager.unit.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerSubjectList",
            code: studeaManagerManager.STUDEA_MANAGER_COURSE,
            access: accessManager.EDIT,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_SETTINGS_SUBJECT_EDIT_UNIT_FORM,
          },
        },
      ],
    },
    {
      path: "absence",
      name: "studeaManagerAbsence",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerAbsenceList" },
      meta: {
        title: i18n.global.t("studea_manager.absence.list.title"),
        breadcrumb: true,
        code: "STUDEA_MANAGER_ABSENCE",
        generic: "studea_manager",
      },
      children: [
        {
          path: "",
          name: "studeaManagerAbsenceList",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Absence/AbsenceView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.absence.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.VIEW,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_ABSENCE_SETTINGS,
          },
        },
        {
          path: ":alias(planning)/list",
          name: "studeaManagerPlanningList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Absence/AbsenceListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.planning.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.VIEW,
          },
        },
        {
          path: ":alias(planning)/add",
          name: "studeaManagerPlanningAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.planning.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerAbsenceList",
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(planning)/edit/:id",
          name: "studeaManagerPlanningEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.planning.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerAbsenceList",
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(planning)/emargement/edit/:id",
          name: "studeaManagerPlanningSignaturetEdit",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Absence/AbsenceSignatureEdit.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("absence.signature.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerAbsenceList",
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(planning)/import",
          name: "studeaManagerPlanningImport",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/ImportView.vue"),
          meta: {
            title: i18n.global.tc("global.import.title", 1, {
              name: i18n.global.tc("studea_manager.planning.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerAbsenceList",
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(absence)/list",
          name: "studeaManagerAbsenceAbsenceList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Absence/AbsenceListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.absence.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(absence)/add",
          name: "studeaManagerAbsenceAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 2, {
              name: i18n.global.tc("studea_manager.absence.title", 1).toLowerCase(),
            }),
            postNotGeneric: true,
            notGeneric: false,
            breadcrumb: true,
            backPath: "studeaManagerAbsenceList",
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(absence)/edit/:id",
          name: "studeaManagerAbsenceEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.absence.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerAbsenceList",
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
            putNotGeneric: true,
            notGeneric: false,
          },
        },
        {
          path: ":alias(absence)/import",
          name: "studeaManagerAbsenceImport",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/ImportView.vue"),
          meta: {
            title: i18n.global.tc("global.import.title", 1, {
              name: i18n.global.tc("studea_manager.absence.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerAbsenceList",
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
          },
        },
        {
          path: ":alias(attendance-certificate)/list",
          name: "studeaManagerAbsenceAttendanceist",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Absence/AttendanceCertificateListView.vue"),
          meta: {
            title: i18n.global.t("absence.list_of_attendance_certificate"),
            breadcrumb: true,
            code: studeaManagerManager.STUDEA_MANAGER_ABSENCE,
            access: accessManager.EDIT,
          },
        },
      ],
    },
    {
      path: "registration",
      name: "studeaManagerRegistration",
      component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/HomeView.vue"),
      meta: {
        title: i18n.global.tc("global.list.title", 2, {
          name: i18n.global.tc("studea_manager.registration.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_REGISTRATION,
        generic: "studea_manager",
        access: accessManager.VIEW,
      },
    },
    {
      path: "notepad",
      name: "studeaManagerNotepad",
      component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/HomeView.vue"),
      meta: {
        title: i18n.global.tc("global.list.title", 2, {
          name: i18n.global.tc("studea_manager.notepad.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_NOTE,
        access: accessManager.VIEW,
        generic: "studea_manager",
      },
    },
    {
      path: ":alias(document)",
      name: "studeaManagerDocument",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerDocumentList" },
      meta: {
        title: i18n.global.tc("global.list.title", 1, {
          name: i18n.global.tc("studea_manager.document.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_DOCUMENTS_UPLOAD,
        access: accessManager.VIEW,
        generic: "studea_manager",
      },
      children: [
        {
          path: "",
          name: "studeaManagerDocumentList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Document/DocumentListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.document.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_DOCUMENTS_UPLOAD,
            access: accessManager.VIEW,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_DOCUMENT_SETTINGS,
          },
        },
        {
          path: "add",
          name: "studeaManagerDocumentAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.document.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            backPath: "studeaManagerDocumentList",
            postNotGeneric: true,
            code: studeaManagerManager.STUDEA_MANAGER_DOCUMENTS_UPLOAD,
            access: accessManager.EDIT,
          },
        },
        {
          path: "edit/:id",
          name: "studeaManagerDocumentEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.document.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            backPath: "studeaManagerDocumentList",
            putNotGeneric: true,
            code: studeaManagerManager.STUDEA_MANAGER_DOCUMENTS_UPLOAD,
            access: accessManager.EDIT,
          },
        },
      ],
    },
    {
      path: "contract-rupture",
      name: "studeaManagerTriadDeclareContractRupture",
      component: () =>
        import(
          /* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Triad/ContractRuptureDeclarationView.vue"
        ),
      meta: {
        title: i18n.global.tc("global.list.title", 2, {
          name: i18n.global.tc("studea_manager.webLink.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_TRIAD_DECLARE_CONTRACT_RUPTURE,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_CONTRACT_BREAK_SETTINGS,
      },
    },
    {
      path: ":alias(web-link)",
      name: "studeaManagerWebLink",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerWebLinkList" },
      meta: {
        title: i18n.global.tc("global.list.title", 2, {
          name: i18n.global.tc("studea_manager.webLink.title", 2).toLowerCase(),
        }),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_WEBLINKS,
        generic: "studea_manager",
      },
      children: [
        {
          path: "",
          name: "studeaManagerWebLinkList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/WebLink/WebLinkListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 2, {
              name: i18n.global.tc("studea_manager.webLink.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_WEBLINKS,
            access: accessManager.VIEW,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_WEBLINKS_SETTINGS,
          },
        },
        {
          path: "add",
          name: "studeaManagerWebLinkAdd",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.webLink.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerWebLinkList",
            code: studeaManagerManager.STUDEA_MANAGER_WEBLINKS,
            access: accessManager.EDIT,
          },
        },
        {
          path: "edit/:id",
          name: "studeaManagerWebLinkEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.webLink.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            backPath: "studeaManagerWebLinkList",
            code: studeaManagerManager.STUDEA_MANAGER_WEBLINKS,
            access: accessManager.EDIT,
          },
        },
      ],
    },
    {
      path: "messaging",
      name: "studeaManagerMessaging",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "studeaManagerMessagingList" },
      meta: {
        title: i18n.global.t("studea_manager.messaging.list.title"),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_MESSAGE_CONTACT,
        access: accessManager.VIEW,
      },
      children: [
        {
          path: "",
          name: "studeaManagerMessagingList",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Chat/ChatView.vue"),
          meta: {
            title: i18n.global.t("studea_manager.messaging.list.title"),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_MESSAGE_CONTACT,
            access: accessManager.VIEW,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_MODULE_MESSAGE_SETTINGS,
          },
        },
        {
          path: ":id",
          name: "studeaManagerMessagingShow",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Chat/ChatView.vue"),
          meta: {
            title: i18n.global.t("page.message"),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_MESSAGE_CONTACT,
            access: accessManager.VIEW,
          },
        },
        {
          path: "new",
          name: "studeaManagerMessagingNew",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Chat/ChatView.vue"),
          meta: {
            title: i18n.global.t("page.new_message"),
            breadcrumb: true,
            code: studeaManagerManager.STUDEA_MANAGER_MESSAGE_CONTACT,
            access: accessManager.EDIT,
          },
        },
        {
          path: "moderation",
          name: "studeaManagerMessagingModeration",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Message/ModerationListView.vue"),
          meta: {
            title: i18n.global.t("chat.moderation"),
            breadcrumb: true,
            code: studeaManagerManager.STUDEA_MANAGER_MESSAGE_MODERATION,
            access: accessManager.EDIT,
          },
        },
      ],
    },

    {
      path: "dashboard",
      name: "studeaManagerDashboard",
      component: () =>
        import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Dashboard/DashboardView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.dashboard.list.title"),
        breadcrumb: true,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_DASHBOARD,
      },
    },
    {
      path: "gradeBook-dashboard",
      name: "studeaManagerGradeBookDashboard",
      component: () =>
        import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/GradeBook/GradeBookDashboardView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.gradeBookDashboard.list.title"),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_DASHBOARD_NOTE,
        access: accessManager.VIEW,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_GRADEBOOK_DASHBOARD,
      },
    },
    {
      path: "skill-dashboard",
      name: "studeaManagerSkillDashboard",
      component: () =>
        import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Skill/SkillDashboardView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.skillDashboard.list.title"),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_SKILLS_DASHBOARD,
        access: accessManager.VIEW,
      },
    },
    {
      path: "mail",
      name: "studeaManagerMail",
      redirect: { name: "studeaManagerMailsList" },
      meta: {
        title: i18n.global.t("studea_manager.mail.list.title"),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_MAIL,
        access: accessManager.VIEW,
      },
      children: [
        {
          path: "list",
          name: "studeaManagerMailsList",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Mail/MailsListView.vue"),
          meta: {
            title: i18n.global.t("studea_manager.mail.list.title"),
            breadcrumb: false,
            code: studeaManagerManager.STUDEA_MANAGER_MAIL,
            access: accessManager.VIEW,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_HOME_EMAILS,
          },
        },
        {
          path: "view/:id",
          name: "studeaManagerMailView",
          component: () =>
            import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Mail/MailViewView.vue"),
          meta: {
            title: i18n.global.t("studea_manager.mail.data"),
            breadcrumb: true,
            code: studeaManagerManager.STUDEA_MANAGER_MAIL,
            access: accessManager.VIEW,
          },
        },
      ],
    },
    {
      path: "history",
      name: "studeaManagerHistory",
      component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/HomeView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.history.list.title"),
        breadcrumb: true,
        code: studeaManagerManager.STUDEA_MANAGER_HISTORY,
        access: accessManager.VIEW,
      },
    },
  ],
};
